import { Settings } from "lucide-react"
import { useTranslation } from "react-i18next"
import { Button } from "@/shadcn/components/ui/button"
import { IS_MOCK_SERVER_ENABLED } from "../model/env"
import { openMockServerConfigDialog } from "../model/open-config-dialog"
import { hasEnabledMockRequests, useMockServerStore } from "../model/store"
import { Tooltip } from "@/shadcn/components/ui/tooltip"

export function MockServerIndicator() {
  const { t } = useTranslation("mock-server")

  const visible = useMockServerStore(
    (state) => IS_MOCK_SERVER_ENABLED && hasEnabledMockRequests(state)
  )

  if (!visible) {
    return null
  }

  return (
    <div className="pointer-events-none fixed bottom-4 left-4 z-50">
      <div className="pointer-events-auto flex items-center gap-2 rounded-lg border border-primary bg-background/95 px-3 py-2 shadow-lg">
        <span className="text-sm font-medium text-primary">{t("indicatorLabel")}</span>
        <Tooltip content={t("openSettings")} sideOffset={10}>
          <Button
            type="button"
            variant="ghost-primary"
            size="icon-sm"
            aria-label={t("openSettings")}
            onClick={openMockServerConfigDialog}
          >
            <Settings />
          </Button>
        </Tooltip>
      </div>
    </div>
  )
}
